interface IMappingError extends IError {
    tableId: number;
    filterId: number;
    metricId: number;
    reportTemplateId: number;
    relashionshipId: number;
}

class MappingError extends ErrorBase implements IMappingError {
    tableId: number;
    filterId: number;
    metricId: number;
    reportTemplateId: number;
    relashionshipId: number;

    constructor(data: IMappingError) {
        super(data);
        this.type = ErrorTypeEnum.Mapping;
    }

    toString(): string {
        return "";
    }
}